<form-layout (canSave)="canSave" (onSave)="onSaveClick()" (onBack)="onBackClick()" (onNext)="onSaveAndNextClick()">
    <form [formGroup]="mitantragstellerDataForm">
        <div class="flex gap-4 flex-col">
            <kendo-formfield>
                <kendo-label class="form-label" [for]="ausgewaehlteInstitutionId"
                    text="{{'mitantragsteller.institutionselection' | translate}} *"
                    [infotooltip]="'mitantragsteller.institutionselection'"></kendo-label>
                <kendo-combobox formControlName="ausgewaehlteInstitutionId" [valuePrimitive]="true"
                    #ausgewaehlteInstitutionId [allowCustom]="false" [data]="InstitutionItems" [valueField]="'id'"
                    [textField]="'name'" [appinfotext]="'mitantragsteller.institutionselection'" kendoDropDownFilter
                    (valueChange)="OnInstitutionSelectionChange($event)">
                </kendo-combobox>
            </kendo-formfield>

            <kendo-formfield>
                <div class="k-checkbox-wrap">
                    <input id="institutionNotFound" type="checkbox" kendoCheckBox formControlName="customInstitution" />
                    <label for="institutionNotFound" class="k-checkbox-label vertretungsberechtigter3-heading"
                        translate>
                        mitantragsteller.institutionNotFound
                    </label>
                </div>
            </kendo-formfield>

            <institution *ngIf="mitantragstellerDataForm.CustomInstitution.value" class="institution-input"
                [form]="mitantragstellerDataForm.Institution" [disabled]="false">
            </institution>
            <div>
                <h1 class="form-title" translate>contact-data.contactPersonTitle</h1>
                <kontakt class="ansprechpartner-input" [form]="mitantragstellerDataForm.Ansprechperson"
                    kontakttyp="ansprechpartner" [isRequired]="true" [isWeitererAnsprechpartnerChecked]="false">
                </kontakt>
            </div>
            <div>
                <h1 class="form-title" translate>contact-data.authorizedRepresentative</h1>
                <kontakt class="vertretungsberechtigter-input" [form]="mitantragstellerDataForm.Vertretungsberechtigter"
                    kontakttyp="vertretungsberechtigter" [isRequired]="false" [isWeitererAnsprechpartnerChecked]="false">
                </kontakt>
            </div>
        </div>
    </form>
</form-layout>